<div class="space-y-4" itemscope itemtype="https://schema.org/FAQPage">
    @for (faq of sanitizedFaqs; track faq.sys.id) {
        <div>
            <app-faq-contentful-item
                [additionalClasses]="additionalClasses"
                [faq]="faq"></app-faq-contentful-item>
        </div>
    }
</div>
